import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { reverse } from '/@/utils/router';
import CatalogHeader from '/@/v3/catalog/catalog-header';
import FactorInfo from '/@/v3/components/factor-info';
import Title from '/@/v3/components/title';
import * as bugsNotes from './notes/bugs';
import * as pathogensNotes from './notes/pathogens';
import styles from './styles.module.css';

@autobind
export default class AcceleronFactors extends Component {
    static contextTypes = {
        history: PropTypes.object,
    };

    handleGoBack() {
        this.context.history(reverse('catalog.CropProtection.Acceleron'));
    }

    renderHeader() {
        const brand = {
            logoCodename: 'acceleron',
            theme: 'acceleron',
            type: 'crop-protection',
        };
        return <CatalogHeader brand={brand} onGoBack={this.handleGoBack} />;
    }

    renderFactorTitle(title) {
        return (
            <Title size='xl' bolder color='secondary'>
                {_(title)}
            </Title>
        );
    }

    renderFeatures(notes) {
        const features = notes.featuresNotes;
        return features.map((item) => {
            return <FactorInfo key={item.id} features={item} side={item.side} />;
        });
    }

    render() {
        const notes = this.props.id == 'bugs' ? bugsNotes : pathogensNotes;
        return (
            <div className={styles.root}>
                {this.renderHeader()}
                <div className={styles.title}>{this.renderFactorTitle(notes.title)}</div>
                {this.renderFeatures(notes)}
            </div>
        );
    }
}
